import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {
    IVoceCosto
} from "../../../../../../../utils/interfaces/tannery_production/order_schedule/schede_costo/IVoceCosto";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";


const useApiCreateVoceCosto = (): UseMutationResult<IVoceCosto, CustomAxiosError, any> => {
    const {selectedCompany} = useAuth()
    const queryClient = useQueryClient();

    const {post} = useApiCalls()

    async function doCreate({companyToken, data}: {
        companyToken?: string,
        data: any
    }): Promise<IVoceCosto> {
        try {
            const response = await post(`/api/company/${companyToken}/tannery_production/schede_costo/voci_costo/`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    return useMutation<IVoceCosto, CustomAxiosError, any>(
        {
            mutationFn: (
                data
            ) => {
                return doCreate({
                    companyToken: selectedCompany?.company_token,
                    data
                })
            },
            onSuccess: async (obj) => {
                await queryClient.invalidateQueries({queryKey: ["useApiGetVociCosto"]});
            },
        }
    );
};


export default useApiCreateVoceCosto;